import {Link} from 'react-router-dom';
import {ReactNode} from 'react';
import {AuthLayoutFooter} from './auth-layout-footer';
import {useIsDarkMode} from '@ui/themes/use-is-dark-mode';
import {useSettings} from '@ui/settings/use-settings';
import clsx from 'clsx';
import {Capacitor} from '@capacitor/core';
import {AppStatusBar} from '@common/core/capacitor/app-status-bar';
import {Style} from '@capacitor/status-bar';

interface AuthPageProps {
  heading?: ReactNode;
  message?: ReactNode;
  children: ReactNode;
}
export function AuthLayout({heading, children, message}: AuthPageProps) {
  const {branding, homepage} = useSettings();
  const {
    headerImage,
    headerImageOpacity,
    headerOverlayColor1,
    headerOverlayColor2,
  } = homepage.appearance;
  const isDarkMode = useIsDarkMode();
  const isNative = Capacitor.isNativePlatform();

  let overlayBackground = undefined;

  if (headerOverlayColor1 && headerOverlayColor2) {
    overlayBackground = `linear-gradient(45deg, ${headerOverlayColor1} 0%, ${headerOverlayColor2} 100%)`;
  } else if (headerOverlayColor1) {
    overlayBackground = headerOverlayColor1;
  } else if (headerOverlayColor2) {
    overlayBackground = headerOverlayColor2;
  }

  if (isNative) {
    AppStatusBar.Style({style: Style.Dark});
  }

  const Wrapper: any = isNative ? 'div' : Link;
  const wrapperProps = isNative ? {} : {to: '/'};
  const Logo = (
    <>
      <img
        src={
          isDarkMode ? branding.logo_light_mobile : branding.logo_dark_mobile
        }
        className="m-auto block h-120 w-auto"
        alt=""
      />
      <img
        src={isDarkMode ? branding.logo_light : branding.logo_dark}
        className="m-auto block h-50 w-auto"
        alt=""
      />
    </>
  );

  return (
    <main
      className={clsx(
        'flex h-[100vh] flex-col items-center overflow-y-auto bg-alt px-14 pt-70 dark:bg-none md:px-10vw',
      )}
      style={{
        backgroundImage: `url("${headerImage}")`,
      }}
    >
      <div
        className="absolute left-0 top-0 z-10 h-full w-full"
        style={{
          background: overlayBackground,
          opacity: headerImageOpacity,
        }}
      />
      <div className="z-30 mx-auto my-auto w-full max-w-440 rounded-lg bg px-40 pb-32 pt-40 shadow md:shadow-xl">
        <Wrapper className="mb-0 block flex-shrink-0" {...wrapperProps}>
          {Logo}
        </Wrapper>
        {heading && <h1 className="mb-20 text-center text-xl">{heading}</h1>}
        {children}
        {message && <div className="mt-36 text-sm">{message}</div>}
      </div>
      <AuthLayoutFooter />
    </main>
  );
}
